module.exports = "/_next/static/images/phone-note-2-2x-3241e8ade094be37692b901f2433ab21.png.webp";